import Vue from "vue";

export default {
	state: {
		clientList: [],
		clientByUserList: [],
		clientBySupplier: [],
		clientLogo: "",
		clientPagination: {}
	},
	mutations: {
		setClientPaginationOnState(state, clientPagination) {
			state.clientPagination = clientPagination;
		},
		setClientListOnState(state, clientList) {
			state.clientList = clientList;
		},
		setClientByUserListOnState(state, clientByUserList) {
			state.clientByUserList = clientByUserList;
		},
		setClientBySupplierOnState(state, clientBySupplier) {
			state.clientBySupplier = clientBySupplier;
		},
		updateClientIds(state, response) {
			return {
				state,
				response
			};
		},
		setClientLogoOnState(state, logo) {
			state.clientLogo = logo;
		}
	},
	actions: {
		createClient(_, client) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("client", client)
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							this.state.loading = false;
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						resolve();
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		updateClient(_, client) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("client", client)
					.then((response) => {
						this.state.loading = false;
						if (response.error) {
							this.state.loading = false;
							Vue.prototype.$functions.displayError(this._vm, response.error);
							return;
						}
						resolve();
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error.response.data.error.message);
					});
			});
		},
		updateClientId({ commit }, newClientId) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("client/updateClientId", { newIdClient: newClientId })
					.then((response) => {
						commit("updateClientIds", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		},
		getClientList({ commit }, filter) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http.get("client/clientList", filter).then((response) => {
					this.state.loading = false;
					if (response.error) {
						Vue.prototype.$functions.displayError(this._vm, response.error);
						return;
					}
					commit("setClientListOnState", response.data.data.list);
					commit("setClientPaginationOnState", response.data.data.pagination);
					resolve(response.data.data.pagination);
				});
			});
		},
		getAllClients({ commit }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("client")
					.then((response) => {
						this.state.loading = false;
						commit("setClientListOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getClientByKey(_, clientKey) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("clientInfo/" + clientKey)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getClientsByUser({ commit }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("client/user")
					.then((response) => {
						this.state.loading = false;
						commit("setClientByUserListOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getClientBySupplier({ commit }, filter) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.post("client/supplier", filter)
					.then((response) => {
						this.state.loading = false;
						let mappedSuppliers = mapFormatCnpjCpfSuppliers(response.data.data);
						commit("setClientBySupplierOnState", mappedSuppliers);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getClientLogo({ commit }, idClient) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("client/logo/" + idClient)
					.then((response) => {
						commit("setClientLogoOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		},
		getClientModels() {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("client/clientModels")
					.then((response) => {
						resolve(response.data.data);
					})
					.catch(() => {
						reject();
					});
			});
		}
	},
	getters: {
		clientList({ clientList }) {
			return clientList;
		},
		clientByUserList({ clientByUserList }) {
			return clientByUserList;
		},
		clientBySupplier({ clientBySupplier }) {
			return clientBySupplier;
		},
		logo({ clientLogo }) {
			return "data:image/png;base64," + clientLogo.base64Image;
		},
		clientPagination({ clientPagination }) {
			return clientPagination;
		}
	}
};

function mapFormatCnpjCpfSuppliers(suppliers) {
	return suppliers.map((supplier) => {
		const formattedCnpj = Vue.prototype.$functions.cnpjCpfFormatFromBack(supplier.cnpj);
		const formattedCnpjSupplier = Vue.prototype.$functions.cnpjCpfFormatFromBack(supplier.supplierCnpjCpf);
		return {
			...supplier,
			cnpj: formattedCnpj,
			supplierCnpjCpf: formattedCnpjSupplier,
			supplierName: supplier.supplierName
		};
	});
}
